import type { BucketKey } from '@/entities/bucket';
import request from '@/shared/api/request';

export const getBucketsKeys = (): Promise<{ keys: BucketKey }> =>
  request({
    url: '/buckets/keys/',
  });
